import { useEffect, useState } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ICustomService } from "./common/SelectYourNumber/interface/ISubscription";
import { URLS } from "./constants";
import { AccountDetailsPage } from "./pages/AccountDetails/AccountDetailsPage";
import { AlertListPage } from "./pages/AlertList/AlertListPage";
import { BarringsPage } from "./pages/Barrings/BarringsPage";
import { BillsPage } from "./pages/Bills/BillsPage";
import { EmailVerificationPage } from "./pages/EmailVerification/EmailVerificationPage";
import { ForgotEmailPage } from "./pages/ForgotEmail/ForgotEmailPage";
import { HomePage } from "./pages/Home/HomePage";
import { ManageSimPage } from "./pages/ManageSim/ManageSimPage";
import { OrderPage } from "./pages/Order/OrderPage";
import { PaymentPage } from "./pages/Payment/PaymentPage";
import { PortInPage } from "./pages/PortIn/PortInPage";
import { ProfilePage } from "./pages/Profile/ProfilePage";
import { AuthRoute, NonAuthRoute } from "./Routes";
import "./stylesheets/index.scss";
import { getSelectedService, saveSelectedService } from "./utils/storage";
import { UsagePage } from "./pages/Usage/UsagePage";
import { SelectedServiceContext } from "./context/ISelectedContext";
import { ScrollTopButton } from "@common/scrollTopButton/ScrollTop";
import { Footer } from "@common/footer/Footer";
import ManageMobileServicesPage from "@pages/ManageMobileServices/ManageMobileServicesPage";
import ResetCreditLimitPage from "@pages/ResetCreditLimit/ResetCreditLimitPage";
import TerminateNumberPage from "@pages/TerminateNumber/TerminateNumberPage";
import ContactPage from "@pages/Contact/ContactPage";
import { useTwoWayAuthContext } from "@context/TwoWayAuthContext";
import { TwoWayAuthPage } from "@pages/TwoWayAuth/TwoWayAuthPage";
import { getLanguage } from "@utils/changeLanguage";

export const App = () => {
    const [selectedService, setSelectedService] = useState<ICustomService | undefined>(getSelectedService());
    const { isTwoWayAuthenticated } = useTwoWayAuthContext();
    const lang = getLanguage();

    useEffect(() => {
        saveSelectedService(selectedService);
    }, [selectedService]);

    const getRedirectHomeUrl = (): string => {
        return lang === "en" || !lang ? URLS.HOME_PAGE_URL_EN : URLS.HOME_PAGE_URL_EL;
    };

    const getRedirectTwoWayAuthUrl = (): string => {
        return lang === "en" || !lang ? URLS.TWO_WAY_AUTH_OTP_URL_EN : URLS.TWO_WAY_AUTH_OTP_URL_EL;
    };

    return (
        <div id="app-container">
            <SelectedServiceContext.Provider value={{ selectedService, setSelectedService }}>
                <div style={{ flexGrow: 1 }}>
                    <Switch>
                        <AuthRoute component={HomePage} exact path={URLS.HOME_PAGE_URL_EN} />
                        <AuthRoute component={ProfilePage} exact path={URLS.PROFILE_PAGE_URL_EN} />
                        <AuthRoute component={BillsPage} exact path={URLS.BILLS_PAGE_URL_EN} />
                        <AuthRoute component={UsagePage} exact path={URLS.USAGE_PAGE_URL_EN} />
                        <AuthRoute component={AccountDetailsPage} exact path={URLS.ACCOUNT_DETAILS_PAGE_URL_EN} />
                        <AuthRoute component={OrderPage} exact path={URLS.ORDERS_PAGE_URL_EN} />
                        <AuthRoute component={AlertListPage} exact path={URLS.ALERTS_PAGE_URL_EN} />
                        <AuthRoute component={PaymentPage} exact path={URLS.PAYMENTS_PAGE_URL_EN} />
                        <AuthRoute component={PortInPage} exact path={URLS.PORTIN_PAGE_URL_EN} />
                        <AuthRoute component={ManageSimPage} exact path={URLS.MANAGE_SIM_URL_EN} />
                        <AuthRoute component={BarringsPage} exact path={URLS.BARRINGS_PAGE_URL_EN} />
                        <AuthRoute component={ResetCreditLimitPage} exact path={URLS.RESET_CREDIT_LIMIT_URL_EN} />
                        <AuthRoute component={TerminateNumberPage} exact path={URLS.TERMINATE_NUMBER_URL_EN} />
                        <AuthRoute
                            component={ManageMobileServicesPage}
                            exact
                            path={URLS.MANAGE_MOBILE_SERVICES_URL_EN}
                        />
                        <AuthRoute component={ContactPage} exact path={URLS.SUBMIT_DOCUMENTS_URL_EN} />
                        <AuthRoute component={TwoWayAuthPage} exact path={URLS.TWO_WAY_AUTH_OTP_URL_EN} />
                        <NonAuthRoute component={ForgotEmailPage} exact path={URLS.FORGOTEMAIL_PAGE_URL_EN} />
                        <NonAuthRoute
                            component={EmailVerificationPage}
                            exact
                            path={URLS.EMAILVERIFICATION_PAGE_URL_EN}
                        />
                        <AuthRoute component={HomePage} exact path={URLS.HOME_PAGE_URL_EL} />
                        <AuthRoute component={ProfilePage} exact path={URLS.PROFILE_PAGE_URL_EL} />
                        <AuthRoute component={BillsPage} exact path={URLS.BILLS_PAGE_URL_EL} />
                        <AuthRoute component={UsagePage} exact path={URLS.USAGE_PAGE_URL_EL} />
                        <AuthRoute component={AccountDetailsPage} exact path={URLS.ACCOUNT_DETAILS_PAGE_URL_EL} />
                        <AuthRoute component={OrderPage} exact path={URLS.ORDERS_PAGE_URL_EL} />
                        <AuthRoute component={AlertListPage} exact path={URLS.ALERTS_PAGE_URL_EL} />
                        <AuthRoute component={PaymentPage} exact path={URLS.PAYMENTS_PAGE_URL_EL} />
                        <AuthRoute component={PortInPage} exact path={URLS.PORTIN_PAGE_URL_EL} />
                        <AuthRoute component={ManageSimPage} exact path={URLS.MANAGE_SIM_URL_EL} />
                        <AuthRoute component={BarringsPage} exact path={URLS.BARRINGS_PAGE_URL_EL} />
                        <AuthRoute component={ResetCreditLimitPage} exact path={URLS.RESET_CREDIT_LIMIT_URL_EL} />
                        <AuthRoute component={TerminateNumberPage} exact path={URLS.TERMINATE_NUMBER_URL_EL} />
                        <AuthRoute
                            component={ManageMobileServicesPage}
                            exact
                            path={URLS.MANAGE_MOBILE_SERVICES_URL_EL}
                        />
                        <AuthRoute component={ContactPage} exact path={URLS.SUBMIT_DOCUMENTS_URL_EL} />
                        <AuthRoute component={TwoWayAuthPage} exact path={URLS.TWO_WAY_AUTH_OTP_URL_EL} />
                        <NonAuthRoute component={ForgotEmailPage} exact path={URLS.FORGOTEMAIL_PAGE_URL_EL} />
                        <NonAuthRoute
                            component={EmailVerificationPage}
                            exact
                            path={URLS.EMAILVERIFICATION_PAGE_URL_EL}
                        />
                        <Redirect to={isTwoWayAuthenticated ? getRedirectHomeUrl() : getRedirectTwoWayAuthUrl()} />
                    </Switch>
                </div>
                <ScrollTopButton />
                <Footer />
            </SelectedServiceContext.Provider>
        </div>
    );
};
